<template>
  <div class="container-lg max-min-width py-3">
    <!-- begin filter -->
    <div class="row position-relative mb-6" v-if="filterList.length > 0">
      <div class="col-12">
        <div class="row filter-position">
          <div class="col-md-11 col-lg-9 mx-auto">
            <div class="card p-3 shadow">
              <div class="row">
                <div class="col-10">
                  <div class="filter-wrapper">
                    <div
                      class="d-inline-block me-2"
                      v-for="(item, index) in filterList"
                      :key="item"
                    >
                      <div
                        class="
                          custom-d-flex
                          bg-light-green
                          custom-border-radius
                          mb-2
                        "
                      >
                        <span class="filter-item px-2">{{ item }}</span>
                        <button
                          type="button"
                          class="btn"
                          @click="removeItem(item, index)"
                        >
                          <div class="icon-remove-wrapper">
                            <img
                              src="../assets/images/icon-remove.svg"
                              alt="icon remove"
                              class="img-fluid"
                              width="11"
                            />
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-2 text-md-end">
                  <button
                    type="button"
                    class="btn btn-clear"
                    @click="removeAll"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end filter -->
    <div class="row">
      <div class="col-md-11 col-lg-9 mx-auto">
        <!-- begin list -->
        <ul class="list-unstyled">
          <li
            v-for="data in getData"
            :key="data.id"
            class="card p-3 shadow"
            :class="{ 'green-border': data.featured }"
          >
            <div
              class="
                row
                custom-d-flex
                justify-content-between
                flex-wrap
                sm-space
              "
            >
              <div class="col-sm-7 col-md-6">
                <div class="custom-d-flex position-relative">
                  <div class="me-3 sm-img-container">
                    <img
                      :src="require(`@/assets/images/${data.logo}`)"
                      :alt="data.company"
                      class="img-fluid"
                    />
                  </div>
                  <div>
                    <header class="mb-1">
                      <span class="text-green me-2">{{ data.company }}</span>
                      <div
                        class="custom-badge custom-badge-green mx-2"
                        v-if="data.new"
                      >
                        <span class=""> New! </span>
                      </div>
                      <div
                        class="custom-badge custom-badge-dark"
                        v-if="data.featured"
                      >
                        <span class=""> Featured </span>
                      </div>
                    </header>
                    <h5 class="position">{{ data.position }}</h5>
                    <div class="footer custom-d-flex">
                      <span>{{ data.postedAt }}</span>
                      <span class="mx-3 dot"></span>
                      <span>{{ data.contract }}</span>
                      <span class="mx-3 dot"></span>
                      <span>{{ data.location }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-sm-none">
                <div class="col-12">
                  <div class="border-bottom my-3"></div>
                </div>
              </div>
              <div class="col-sm-5 col-md-6">
                <div
                  class="custom-d-flex justify-content-md-end flex-wrap"
                  ref="btnContainer"
                >
                  <button type="button" class="btn mb-1" @click="addItems">
                    <span>{{ data.role }}</span>
                  </button>
                  <button type="button" class="btn mb-1" @click="addItems">
                    <span>{{ data.level }}</span>
                  </button>
                  <button
                    type="button"
                    class="btn mb-1"
                    v-for="language in data.languages"
                    :key="language"
                    @click="addItems"
                  >
                    <span> {{ language }}</span>
                  </button>
                  <div
                    v-if="data.tools.length > 0"
                    class="custom-d-flexx d-inline-block"
                  >
                    <button
                      type="button"
                      class="btn mb-1"
                      v-for="tool in data.tools"
                      :key="tool"
                      @click="addItems"
                    >
                      <span> {{ tool }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!-- end list -->
      </div>
    </div>
  </div>
</template>

<script >

export default {
  computed: {
    getData() {
      return this.$store.getters.getList;
    },
    filterList() {
      return this.$store.getters.getFilteredList;
    },
  },
  methods: {
    getListData() {
      this.$store.dispatch("getJobList");
    },
    addItems(e) {
      this.$store.dispatch("addItems", e);
      this.$store.dispatch("filterItems");
      
    },

    removeItem(item, index) {
      this.$store.dispatch("removeItem", {
        item: item,
        index: index,
      });
    },
    removeAll() {
      this.$store.dispatch("removeAll");
    },
  },

  mounted() {
    this.getListData();
  },
};
</script>

<style lang="scss" scoped>
/** Variables */
$desaturated-dark-cyan: hsl(180, 29%, 50%);

$light-grayish-cyan-Background: hsl(180, 52%, 96%);
$light-grayish-cyan: hsl(180, 31%, 95%);
$dark-grayish-cyan: hsl(180, 8%, 52%);
$very-dark-grayish-cyan: hsl(180, 14%, 20%);

ul img {
  width: 70px;
}

.custom-badge {
  display: inline-block;
  position: relative;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  padding: 0.35em 0.65em;
  text-transform: uppercase;
  border-radius: 15px;
  text-align: center;
  line-height: 1;
}

.custom-badge-text {
  position: absolute;
}

.custom-badge-green {
  background-color: $desaturated-dark-cyan;
}

.custom-badge-dark {
  background-color: $very-dark-grayish-cyan;
}

.text-green {
  font-weight: 700;
  color: $desaturated-dark-cyan;
}

.custom-d-flex {
  display: flex;
  align-items: center;
}

.position {
  font-size: 1.19rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
  color: $very-dark-grayish-cyan;
  cursor: pointer;
  transition: all linear 400ms;
}

.position:hover {
  color: $desaturated-dark-cyan;
}

.footer span {
  font-size: 14px;
  color: $dark-grayish-cyan;
  font-weight: 500;
}

.btn {
  box-shadow: none;
  padding: 0;
}

.btn-clear {
  font-size: 12px;
  font-weight: 700;
  color: $very-dark-grayish-cyan;
  transition: all linear 300ms;
}

.btn-clear:hover {
  color: $desaturated-dark-cyan;
  text-decoration: underline;
}

ul .btn {
 
  padding: 0.1rem 0.3rem;

  font-size: 12px;
  font-weight: 700;
  color: $desaturated-dark-cyan;
  margin-right: 0.5rem;
  background-color: $light-grayish-cyan;
  vertical-align: middle;
  transition: all linear 400ms;
}

ul .btn:hover {
  background-color: $desaturated-dark-cyan;
  color: $light-grayish-cyan-Background;
}

ul .btn span {
  display: inline-block;
  align-self: center;
}

ul {
 
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

ul li:not(:last-child) {
  margin-bottom: 1rem;
}

.card {
  border-color: transparent !important;
  border-radius: 0.5rem;
}

.green-border {
  border-left: 5px solid $desaturated-dark-cyan !important;
  
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(91, 164, 164, 0.3) !important;
}

.dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: $dark-grayish-cyan;
}

.filter-item {
  font-size: 12px;
  font-weight: 700;
  color: $desaturated-dark-cyan;
}

.bg-light-green {
  background-color: $light-grayish-cyan;
}

.filter-wrapper {
  .btn {
    background-color: $desaturated-dark-cyan;
    text-align: center;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;

    transition: all linear 400ms;
  }
}

.filter-wrapper .btn:hover {
  background-color: $very-dark-grayish-cyan;
}

.icon-remove-wrapper {
  position: relative;
  width: 23px;
  height: 23px;
  text-align: center;
}

.icon-remove-wrapper img {
  position: absolute;
  left: 25%;
  top: 50%;
  transform: translateY(-50%);
}

.custom-border-radius {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.filter-position {
  position: absolute;
  width: 100%;
  top: -46px;
}

@media screen and (max-width: 575px) {
  ul li:not(:last-child) {
    margin-bottom: 3.4rem;
  }

  .sm-img-container {
    position: absolute;
    top: -85px;
  }

  .sm-space {
    margin-top: 2rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .position {
    font-size: 1rem;
    margin-bottom: 0.7rem;
    margin-top: 0.5rem;
  }

  .custom-badge {
    font-size: 12px;
    padding: 0.4em 0.75em;
  }

  ul .btn {
    padding: 0.1rem 0.3rem;
    font-size: 14px;
    margin-right: 0.8rem;
    margin-bottom: 0.7rem !important;
  }

  .mb-6 {
    margin-bottom: 4.8rem;
  }
  .filter-position {
    top: -53px;
  }
}
</style>